const isPrimitive = (val: any): boolean => {
  if (val === null){
      return true;
  }

  return typeof val !== "object" && typeof val !== "function"
}

function fullDeepCopy<T>(obj: T, objectCache: Map<any, any>): T {
  if (objectCache.has(obj)) {
    return objectCache.get(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map(a => fullDeepCopy(a, objectCache)) as T;
  }

  if (isPrimitive(obj)) {
    return obj;
  }

  const newObj = {...obj} as any;
  // each non primitive field has to be deep coppied

  Object.keys(obj as any).forEach(key => {
    const val = newObj[key];

    if (val === null){
      return;
    }

    if (typeof val === "object"){
      newObj[key] = fullDeepCopy(val, objectCache);
    }
  })


  return newObj;
}

export function deepCopy(obj: undefined): undefined;
export function deepCopy<T>(obj: T): T;
export function deepCopy(obj: any): any {
  if (obj === undefined) {
    return undefined;
  }
  if (obj === null) {
    return null;
  }

  const objectCache = new Map<any, any>();
  return fullDeepCopy(obj, objectCache);
}
